import React from "react"

import { FEATURES_TYPE } from "@constants"
import AppLayout from "Layout"
import { BUSINESS_LOGISTICS_ROUTES } from "@constants/routes"
import EuropcarPricingEnvironmentPage from "./PricingEnvironment/Page";
import EuropcarAnalyticsPage from "./Analytics/Page";
import BIPage from "./BI/Page";
import LeadingAnalyzerPage from "./LeadingAnalyzer/Page";
import SeasonVsLastYearPage from "./Dashboards/SeasonVsLastYear/Page";
import PriceCurvePage from "./Dashboards/PriceCurve/Page";
import OfficeNetworkPage from "./Dashboards/OfficeNetwork/Page";
import { Navigate } from "react-router-dom";
import { businessLogisticsChildren, sectionIndexPath, MENU_KEYS } from "./@services/menu";


// The page of each menu entry; the order and the flags live in `@services/menu.js` (CU-869fmhmx8 D13)
const ELEMENTS = {
	[MENU_KEYS.SEASON_VS_LY]: <SeasonVsLastYearPage/>,
	[MENU_KEYS.PRICE_CURVE]: <PriceCurvePage/>,
	[MENU_KEYS.OFFICE_NETWORK]: <OfficeNetworkPage/>,
	[MENU_KEYS.EUROPCAR]: <EuropcarAnalyticsPage/>,
	[MENU_KEYS.PRICING_ENV]: <EuropcarPricingEnvironmentPage/>,
	[MENU_KEYS.LEADING]: <LeadingAnalyzerPage/>,
	[MENU_KEYS.ADVANCED]: <BIPage/>,
}

export const BusinessLogisticsRoutes = userData => {
	const features = userData?.featuresV2 || {}
	const children = businessLogisticsChildren(features, BUSINESS_LOGISTICS_ROUTES, { today: new Date() })
		.map(({ key, path, title, badge }) => ({ path, title, element: ELEMENTS[key], ...(badge && { badge }) }))

	if (children.length > 0) {
		return [{
			id: FEATURES_TYPE.COMMON,
			path: BUSINESS_LOGISTICS_ROUTES.PATH,
			title: BUSINESS_LOGISTICS_ROUTES.TITLE,
			icon: 'chart-line',
			element: <AppLayout/>,
			children: [{
				// The header opens Advanced (BI) with `bi`, else the first entry (Curro's decision 6)
				element: <Navigate to={sectionIndexPath(features, BUSINESS_LOGISTICS_ROUTES)} replace/>, index: true
			}, ...children]
		}]
	}

	return []
}
